import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Form, Row, Image } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import FalconCardHeader from 'components/common/FalconCardHeader';
import 'react-toastify/dist/ReactToastify.css';
import './ProfileSettings.css'; // Custom CSS file for additional styling
import { useAuth } from 'context/AuthWizardContext';

const ProfileSettings = () => {
  const { user } = useAuth();

  console.log()
  const [formData, setFormData] = useState({
    firstName: '',
    email: '',
    phone: '',
    customerName: '',
    intro: '',
    title: '',
    profileImage: '',
    token: '' 
  });

  useEffect(() => {
    console.log(user)
    if (user) {
      setFormData({
        token: user.token,
        firstName: user.username || '',
        email: user.email || '',
        phone: user.phone || '',
        customerName: user.customerName || '',
        intro: user.introText || '',
        title: user.title || '', // Assuming user has a title field
        profileImage: user.ppURL || null // Assuming user has a profileImage field
      });
    }
  }, [user]);

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = e => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      // Maximum file size: 2MB
      if (file.size > 2 * 1024 * 1024) {
        toast.error('File size must be less than 2MB.');
        return;
      }

      // Only accept specific file formats and size constraints
      if (file.type.startsWith('image/') && ['image/jpeg', 'image/png'].includes(file.type)) {
        setFormData({
          ...formData,
          profileImage: file
        });
      } else {
        toast.error('Only JPEG and PNG formats are allowed.');
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    
    const requestData = new FormData();
    requestData.append('process', '100019322'); // Process ID
    requestData.append('uname', `${formData.firstName}`);
    requestData.append('email', formData.email);
    requestData.append('phone', formData.phone);
    requestData.append('intro', formData.intro);
    requestData.append('title', formData.title);
    requestData.append('token', user.token);
    requestData.append('pp_path', formData.profileImage);
    
    // Log the form data content to the console
    for (let pair of requestData.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }
  
    try {
      const response = await axios.post('https://musteri.guardnet.com.tr/call.php', requestData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log(response.data);
  
      if (response.data.success) {
        toast.success('Profil başarıyla güncellendi!');
        // Sayfayı yenilemek için
        window.location.reload();
      } else {
        toast.error('Güncelleme başarısız: ' + response.data.message);
      }
    } catch (error) {
      toast.error('Bir hata oluştu: ' + error.message);
    }
  };
  

  return (
    <Card className="profile-settings-card">
      <FalconCardHeader title="Profile Settings" />
      <Card.Body className="bg-light">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-4 justify-content-center">
            <Col md={3} className="text-center"> {/* Reduced column size */}
              <div className="profile-image-wrapper">
                <Image
                  src={user.ppURL}
                  roundedCircle
                  fluid
                  className="profile-image-small"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
                <Form.Control
                  type="file"
                  accept="image/jpeg, image/png"
                  className="mt-2"
                  onChange={handleImageChange}
                />
                <Form.Text className="text-muted">
                  Only JPEG and PNG formats are allowed. Max size: 2MB.
                </Form.Text>
              </div>
            </Col>
          </Row>

          <Row className="mb-3 g-2"> {/* Reduced spacing */}
            <Form.Group as={Col} lg={6} controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="First Name"
                value={formData.firstName}
                name="firstName"
                onChange={handleChange}
                className="custom-input-small"
              />
            </Form.Group>

          </Row>

          <Row className="mb-3 g-2">
            <Form.Group as={Col} lg={6} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={formData.email}
                name="email"
                onChange={handleChange}
                className="custom-input-small"
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="phone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Phone"
                value={formData.phone}
                name="phone"
                onChange={handleChange}
                className="custom-input-small"
              />
            </Form.Group>
          </Row>

          <Form.Group className="mb-3" controlId="customerName">
            <Form.Label>Customer Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Customer Name"
              value={formData.customerName}
              name="customerName"
              onChange={handleChange}
              className="custom-input-small"
              readOnly
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="intro">
            <Form.Label>Intro</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Intro"
              value={formData.intro}
              name="intro"
              onChange={handleChange}
              className="custom-input-small"
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="title">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Title"
              value={formData.title}
              name="title"
              onChange={handleChange}
              className="custom-input-small"
            />
          </Form.Group>

          <div className="text-end">
            <Button variant="primary" type="submit" className="custom-button-small">
              Update
            </Button>
          </div>
        </Form>
      </Card.Body>

      {/* Toast Container */}
      <ToastContainer />
    </Card>
  );
};

export default ProfileSettings;
